import React from "react";
import SettingsToggler from "./SettingsToggler";

const ComponentContainer: React.FC = (props) => {
  return <SettingsToggler {...props} />;
};

export default ComponentContainer;
